import styled from 'styled-components';
export const StyledIframeWrapper = styled.div.withConfig({
  displayName: "StyledIframeWrapper",
  componentId: "sc-1awoae-0"
})(["display:block !important;all:initial;width:min-content;height:min-content;transition:none !important;> iframe{all:initial;transition:width 0.1s ease-in,height 0.1s ease-in !important;background:none;}"]);